import { Div, Flex } from '@fastnorth/kraken/components/layout';

type UnifiedDisplayMessage = {
  id: string;
  content?: string;
  displaySettings?: {
    displayOnHome?: boolean;
    displayOnListing?: boolean;
    displayOnDetail?: boolean;
    displayOnFollow?: boolean;
    displayOnPosting?: boolean;
  };
};

export type DisplayMessagesProps = { displayMessages: UnifiedDisplayMessage[] };

const DisplayMessages = (props: DisplayMessagesProps): React.JSX.Element => {
  const { displayMessages } = props;

  return (
    <Flex className={'flex-col'} gap={'7'}>
      {displayMessages.map((message) => (
        <Div key={message.id} className={'last:mb-5'}>
          {message.content && (
            <Div
              className={'froala-content'}
              dangerouslySetInnerHTML={{ __html: message.content }}
            />
          )}
        </Div>
      ))}
    </Flex>
  );
};

export default DisplayMessages;
